import { useEffect } from 'react';
import { useStore } from '../../FronteggStoreContext';
import { useSnapshot } from '../../useSnapshot';
export function useRestrictionsState() {
  const state = useStore().store.auth.restrictionsState;
  return useSnapshot(state);
}
export const useRestrictionsActions = () => {
  return useStore().stateActions.auth.restrictionsActions;
};
export const useIpRestrictions = () => {
  const {
    loading,
    data,
    saving,
    error,
    pagination,
    totalPages,
    userIpValid
  } = useRestrictionsState().ipRestrictions;
  const {
    loadIpRestrictions
  } = useRestrictionsActions();
  useEffect(() => {
    if (!data && !loading) {
      loadIpRestrictions();
    }
  }, [loadIpRestrictions, data, loading]);
  return {
    loading,
    saving,
    error,
    data,
    pagination,
    totalPages,
    userIpValid
  };
};
export const useEmailDomainRestrictions = () => {
  const {
    loading,
    data,
    saving,
    error
  } = useRestrictionsState().emailDomainRestrictions;
  const {
    loadEmailDomainRestrictions
  } = useRestrictionsActions();
  useEffect(() => {
    if (!data && !loading) {
      loadEmailDomainRestrictions();
    }
  }, [loadEmailDomainRestrictions, data, loading]);
  return {
    loading,
    saving,
    error,
    data
  };
};